const LocalValues	= () => {
  const localValues = {}

	const set = (identifier, value) => {
		localValues[identifier] = value;
	};

	const unset = (identifier) => {
		if( identifier in localValues === false  )	return;
		delete localValues[identifier];
	};

	const getValue = (identifier) => {
		if( identifier in localValues === false )	return undefined;
		return localValues[identifier];
	}

  return {set, unset, getValue}
};

export default LocalValues();
